var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start"},[_c('img',{staticStyle:{"max-width":"150px","max-height":"112px"},attrs:{"src":_vm.url}}),(_vm.removable)?_c('app-button',{attrs:{"size":"mini","variant":"danger","aria-label":"remove photo","icon":"icon-trash-can-outline"},on:{"click":function($event){return _vm.$emit('delete')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }